import { gql } from "@apollo/client";

export const TOKENS_BY_IDS_QUERY = gql`
  query TokensByIds($ids: [ID!]!) {
    tokens(ids: $ids) {
      id
      symbol
      decimals
      priceUSD
      updatedAt
    }
  }
`;

export const TOKEN_BY_SYMBOL_QUERY = gql`
  query TokenBySymbol($symbol: String!) {
    tokenBySymbol(symbol: $symbol) {
      id
      symbol
      decimals
      priceUSD
      updatedAt
    }
  }
`;

export const CANDLES_QUERY = gql`
  query Candles($marketId: ID!, $interval: String!, $from: Int!, $to: Int!) {
    candles(marketId: $marketId, interval: $interval, from: $from, to: $to) {
      startTime
      open
      high
      low
      close
    }
  }
`;
